import { isObject } from '../isObject/isObject';
/**
 * Checks if passed value is type of Symbol.
 *
 * @param {unknown} value Value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 */
export function isSymbol(value) {
    return (typeof value == 'symbol' || (value && value.constructor === Symbol) || (isObject(value) && Object.prototype.toString.call(value) === '[object Symbol]'));
}
